export default __webpack_public_path__ + "static/media/joy.19663494.jpeg";